import React from "react";
import AdminCrud from "@/components/AdminCrud";

export default function AdminGallery() {
  return (
    <AdminCrud
      title="Galeria"
      resource="gallery"
      initialItem={{ media_type: "image", status: "published", order: 0, albums: [] }}
      fields={[
        { name: "title", label: "Título / Evento", required: true, help: "Ex: Bienal do Livro 2026" },
        { name: "category", label: "Categoria" },
        { name: "media_type", label: "Tipo", type: "select", options: [
          { value: "image", label: "Imagens / Álbuns" }, { value: "video", label: "Vídeo" }
        ]},
        { name: "albums", label: "Álbuns", type: "albums", help: "Crie um ou mais sub-álbuns (ex.: Abertura, Palestras, Encerramento). Cada um recebe suas próprias fotos." },
        { name: "media_url", label: "URL do vídeo (apenas para tipo Vídeo)", help: "Preencha somente quando o tipo for Vídeo (YouTube, Vimeo, etc.)." },
        { name: "thumbnail_url", label: "Capa personalizada (opcional)", type: "image", help: "Se em branco, usamos a primeira foto do primeiro álbum." },
        { name: "order", label: "Ordem", type: "number" },
      ]}
      columns={[
        { name: "title", label: "Título" },
        { name: "category", label: "Categoria" },
        { name: "media_type", label: "Tipo" },
        { name: "albums", label: "Álbuns", render: (r) => (r.albums?.length || 0) },
        { name: "photos", label: "Fotos", render: (r) => (r.albums || []).reduce((s, a) => s + (a.images?.length || 0), 0) },
      ]}
    />
  );
}
